const TargetType = {
  GET_TARGETS: 'GET_TARGETS',
  GET_TARGET: 'GET_TARGET',
  CREATE_TARGET: 'CRAETE_TARGET',
  UPDATE_TARGET: 'UPDATE_TARGET',
  DELETE_TARGET: 'DELETE_TARGET',
}

export default TargetType
